import { Button } from '@shared/ui';
import { useState } from 'react';

import { useExportRefusals } from '../hooks/use-refusals';
import { exportRangeCheck } from '../model/export-range';
import { exportErrorMessage } from '../model/failure';

import type { RequestFilters } from '../model/filters';

/**
 * Exports what is on screen. A range over 90 days is refused here, before any
 * request; the BFF refuses it again. Its failures are shown beside the button.
 */
export function ExportButton({ filters }: { filters: RequestFilters }) {
    const exporting = useExportRefusals();
    const [blocked, setBlocked] = useState<string | undefined>();

    const start = () => {
        const check = exportRangeCheck(filters);
        if (!check.allowed) {
            setBlocked(check.message);
            return;
        }
        setBlocked(undefined);
        exporting.mutate(filters);
    };

    const message = blocked ?? (exporting.error ? exportErrorMessage(exporting.error) : undefined);

    return (
        <div className="flex flex-col gap-1.5">
            <Button variant="ghost" onClick={start} disabled={exporting.isPending}>
                {exporting.isPending ? 'Exporting…' : 'Export CSV'}
            </Button>
            {message && (
                <p
                    role="alert"
                    className="max-w-xs text-[12.5px] text-danger-text"
                    data-testid="unidentified-refusals-export-error"
                >
                    {message}
                </p>
            )}
        </div>
    );
}
